import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnChanges, ViewChild } from '@angular/core';
import { DeprecatedConfirmationDialogComponent } from '@app/components';
import { BaseForm } from '@forms/base.form';
import { BenefitDetail } from '@models/benefits/benefit-detail.model';
import { Benefit } from '@models/benefits/benefit.model';

@Component({
    selector: 'app-form-benefit-coverage',
    templateUrl: './benefit-coverage.template.html',
    styleUrls: ['./benefit-coverage.style.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BenefitCoverageForm extends BaseForm implements OnChanges {
    @Input() benefit: Benefit;
    @Input() benefitDetails: BenefitDetail[];

    @ViewChild('deleteBenefitDetailConfirmationDialog', { static: true })
    deleteBenefitDetailConfirmationDialog: DeprecatedConfirmationDialogComponent;

    groupedBenefitDetails: object[];

    constructor(private changeDetector: ChangeDetectorRef) {
        super();
    }

    onSaveBenefitDetail(): void {}
    onCancelBenefitDetail(benefitDetail: BenefitDetail): void {
        benefitDetail.revert();
    }

    onCreateBenefitDetail(benefitDetail: BenefitDetail): void {
        this.benefitDetails.push(benefitDetail);
        this.groupBenefitDetails();
    }

    ngOnChanges(): void {
        this.groupBenefitDetails();
    }

    onDeleteBenefitDetail(benefitDetail: BenefitDetail): void {
        this.deleteBenefitDetailConfirmationDialog
            .show()
            .then((confirmDelete) => {
                if (!confirmDelete) {
                    return;
                }

                // Find the item to delete, sometimes we dont have ids yet (new benefit)
                const index = this.benefitDetails.findIndex(
                    (bd) =>
                        bd.id === benefitDetail.id &&
                        bd.benefitTypeId === benefitDetail.benefitTypeId &&
                        bd.coverage === bd.coverage &&
                        bd.reimbursement === bd.reimbursement &&
                        bd.description === bd.description
                );

                if (index !== null) {
                    this.benefitDetails.splice(index, 1);
                    this.groupBenefitDetails();
                }
            })
            .catch(() => {});
    }

    private groupBenefitDetails(): void {
        if (!this.benefitDetails) {
            this.groupedBenefitDetails = [];
            this.changeDetector.detectChanges();
            return;
        }

        const groupedObj = [...this.benefitDetails].reduce((prev, cur) => {
            if (!prev[cur['benefitTypeId']]) {
                prev[cur['benefitTypeId']] = [cur];
            } else {
                prev[cur['benefitTypeId']].push(cur);
            }
            return prev;
        }, {});
        this.groupedBenefitDetails = Object.keys(groupedObj).map((key) => ({ key, value: groupedObj[key] }));

        this.changeDetector.detectChanges();
    }
}
